<script setup lang="ts">
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import ParticipantLpHeroSection from '@/components/marketing/participants/ParticipantLpHeroSection.vue'
import ParticipantLpPillarsSection from '@/components/marketing/participants/ParticipantLpPillarsSection.vue'
import ParticipantLpHowItWorksSection from '@/components/marketing/participants/ParticipantLpHowItWorksSection.vue'
import ParticipantLpSpotlightsSection from '@/components/marketing/participants/ParticipantLpSpotlightsSection.vue'
import ParticipantLpTrustSection from '@/components/marketing/participants/ParticipantLpTrustSection.vue'
import ParticipantLpFaqSection from '@/components/marketing/participants/ParticipantLpFaqSection.vue'
import ParticipantLpCtaBannerSection from '@/components/marketing/participants/ParticipantLpCtaBannerSection.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <NavBar />
    <main class="flex-1">
      <ParticipantLpHeroSection />
      <ParticipantLpPillarsSection />
      <ParticipantLpHowItWorksSection />
      <ParticipantLpSpotlightsSection />
      <ParticipantLpTrustSection />
      <ParticipantLpFaqSection />
      <ParticipantLpCtaBannerSection />
    </main>
    <AppFooter />
  </div>
</template>
